import React from 'react'
import css from './AccessKeys.scss'
import SortableTable from 'SF/table/SortableTable'
import AccessKeyRow from './AccessKeyRow'
import PropTypes from "prop-types";


/**
 * Table displayed on the Data Extracts Tenant Admin page under the Access tab. This table allows a tenant to see,
 * create and delete access keys to access data extracts.
 *
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} The access key table in the tenant admin Data Extracts page
 */
const AccessKeys = (props) => {

    const getHeaders = () => {
        const headers = []
        headers.push(
            {content: 'Active'},
            {content: 'Access Key'},
            {content: 'Created On'},
            {content: 'Purpose'},
            {content: 'Actions'}
        )
        return headers
    }

    const renderAccessKey = (user, index) => {
        return <AccessKeyRow {...user}
                             index={index}
                             setIsOpenDeleteAccessKey={props.setIsOpenDeleteAccessKey}
                             setDeleteUserName={props.setDeleteUserName}
                             key={index}
                             setIsOpenUpdateAccessKeyStatus={props.setIsOpenUpdateAccessKeyStatus}
                             onAccessKeyStatusChange={props.onAccessKeyStatusChange}/>
    }

    const getAccessKeyTable = () => {
        if (typeof props.userList === 'undefined' ||
            props.userList.length === 0 ||
            !Array.isArray(props.userList)) {
            return <div
                className={css['no-access-keys']}>No access keys available</div>
        } else {
            return (
                <div>
                    <SortableTable columnToSort="Access Key"
                                   headers={getHeaders()}
                                   items={props.userList}
                                   shouldPaginate={false}
                                   renderItem={renderAccessKey}/>
                </div>
            )
        }
    }

    return (
        <div className={css['access-keys-table']}>
            {getAccessKeyTable()}
        </div>

    )
}

AccessKeys.propTypes = {
    userList: PropTypes.arrayOf(PropTypes.object),
    setIsOpenDeleteAccessKey: PropTypes.func.isRequired,
    setDeleteUserName: PropTypes.func.isRequired,
    setIsOpenUpdateAccessKeyStatus: PropTypes.func.isRequired,
    onAccessKeyStatusChange: PropTypes.func.isRequired
}

export default AccessKeys;

